import React from "react";
//import DoctorCalendar from "./utilities/DoctorCalendar";
import SecretaryHome from "./utilities/SecretaryHome";
class Agenda extends React.Component {
  //props = {};

  componentWillReceiveProps(props) {}
  render() {
    if (this.props.role === "SECRETARY") {
      return (
        <SecretaryHome
          doctorId={null}
          toggleChatModal={this.props.toggleChatModal}
          userName={this.props.userName}
        />
      );
    } else {
      return (
        <SecretaryHome
          doctorId={this.props.doctorId}
          userName={this.props.userName}
          toggleChatModal={this.props.toggleChatModal}
        />
      );
    }
  }
}

export default Agenda;



// WEBPACK FOOTER //
// ./src/components/Agenda.js